import React from 'react';
import '../../styles/landing.css';
import Header from '../../components/landing/Header';
import Hero from '../../components/landing/Hero';
import Features from '../../components/landing/Features';
import FAQ from '../../components/landing/FAQ';
import CTA from '../../components/landing/CTA';
import Footer from '../../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Features />
      <CTA />
      <FAQ />
      <Footer />
    </div>
  );
};

export default LandingPage;
